const TOASTER_MSG = {
    UPDATE_RESOURCES:'Resources updated successfully',
    UPDATE_ROLE_ERROR: 'Failed to update role details',
    UPDATE_ROLE_ERROR_NO_FIELD: 'No field is edited for updating',
    UPDATE_USER:'User details updated successfully',
    UPDATE_USER_FAIL: 'Failed to update user details',
}

export const USER_MGMT_DATA_CNST = {
    TOASTER_MSG,
}
